module.exports = __webpack_public_path__ + "img/outlander_power.29d4c14e.jpg";